export enum ProjectStatus {
    Draft = 'Draft',
    Active = 'Active',
    Completed = 'Completed',
    Archived = 'Archived',
    Abandoned = 'Abandoned',
}
